// extracted by mini-css-extract-plugin
module.exports = {"root":"MultilineEllipsis-module--root--f8a2d1"};